import '@fontsource/sora/400.css';
import '@fontsource/sora/600.css';
import '@fontsource/sora/700.css';
import '@fontsource/sora/800.css';
import './index.css';

import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import I18NProvider from '@risksmart-app/components/src/providers/I18nProvider';
import { getEnv } from '@risksmart-app/components/src/utils/environment';
import { buildSentryEnvironment } from '@risksmart-app/shared/src/utils/sentry';
import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { App } from './App';
import { handleSentryBeforeSend } from './sentryUtils';

if (
  getEnv('REACT_APP_ENVIRONMENT') === 'dev-local' ||
  getEnv('REACT_APP_ENVIRONMENT') === 'dev-cloud' ||
  getEnv('REACT_APP_ENVIRONMENT') === 'staging'
) {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

const sentryBaseEnvironment = getEnv('REACT_APP_ENVIRONMENT');
const sentryRegionId = getEnv('REACT_APP_REGION_ID', true);
const sentryEnvironment = buildSentryEnvironment(
  sentryBaseEnvironment,
  sentryRegionId
);

// TODO: lots of other settings to try out later!!!
Sentry.init({
  dsn: 'https://1a23652fb29f477d42fba242f179f4f2@o4505232398745600.ingest.us.sentry.io/4508121088524288',
  environment: sentryEnvironment,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.0,
  sampleRate: 1.0,
  tracesSampleRate: 1.0,
  beforeSend: handleSentryBeforeSend,
  enabled: getEnv('REACT_APP_ENABLE_SENTRY', true) == 'true',
});

// getElementById returns HTMLElement | null, but 'root' is guaranteed to exist in index.html.
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <I18NProvider>
      <App />
    </I18NProvider>
  </React.StrictMode>
);
